import React from "react";
import { convertHTMLRawStringToHTML, RCCButton, RCCGrid, RCCTextArea, RCCTooltip } from "react-common-components";
import { FieldErrors, FieldValues, UseFormWatch } from "react-hook-form";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import CheckPermission from "../CheckPermission";
import Title from "../Title";
import { IIntba003 } from "./interface";

export interface IFiveWhyItem{
    remove5WhyFunction: (index: number) => void;
    addResponseToCause: (val: string) => void;
		disabled?: boolean;
    register: (RegisterOptions?: any) => void;
    watch: UseFormWatch<FieldValues>;
    errors: FieldErrors<FieldValues>;
    updateFunction:Function;
    field5Why: IIntba003;
    index: number;
		isPresentation?: boolean;
}

const FiveWhyItem: React.FC<IFiveWhyItem> = ({
	remove5WhyFunction,
	addResponseToCause,
	disabled,
	register,
	watch,
	errors,
	updateFunction,
	field5Why,
	index,
	isPresentation
}) => {
	const { translate } = useTranslation();

	return(
		<>
			<React.Fragment key={v4()}>
				<RCCGrid
					container 
					item
					xs={12}
					sm={10}
					md={8}
					spacing={1}
				>


					{!isPresentation ? (
						<>
							<RCCGrid
								container
								item
								xs={12}
								sm={6}
								style={{position: "relative"}}
							>
								<input 
									type="text"
									value={String(field5Why.ina003Id)}
									{...register(`intba003[${index}].ina003Id`)} 
									style={{display: "none"}}
									readOnly
								/>
		
								<RCCTextArea 
									name={`intba003[${index}].ina003Pergunta`}
									label={translate("Por quê?")}
									maxLength={4000}
									register={register}
									defaultValue={field5Why.ina003Pergunta}
									required
									disabled={disabled}
									error={errors.intba003 && errors.intba003[index]?.ina003Pergunta}
									onBlurCapture={() => updateFunction()}
								/>
							</RCCGrid>
		
							<RCCGrid 
								container 
								item 
								xs={12}
								sm={6}
								style={{position: "relative"}}
							>
								<RCCTextArea 
									name={`intba003[${index}].ina003Resposta`}
									label={translate("Resposta")}
									maxLength={4000}
									register={register}
									defaultValue={field5Why.ina003Resposta}
									required
									disabled={disabled}
									error={errors.intba003 && errors.intba003[index]?.ina003Resposta}
									onBlurCapture={() => updateFunction()}
								/>
								<div style={{position: "absolute", display: "flex", top: "4px", right: 0}}>
									<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
										<RCCTooltip
											color="red"
											text={translate("Excluir")}
										>
											<RCCButton
												color="transparent"
												icon={{
													name: "trash",
													color: "var(--red)"
												}}
												layout="isRounded"
												onClick={() => remove5WhyFunction(index)}
												disabled={disabled}
												tabIndex={-1}
											/>
										</RCCTooltip>
									</CheckPermission>
									<RCCTooltip
										color="purple"
										text={translate("Adicionar resposta à causa")}
									>
										<RCCButton
											color="transparent"
											icon={{
												name: "check",
												color: "var(--purple)"
											}}
											layout="isRounded"
											onClick={() => {
												addResponseToCause(watch(`intba003[${index}].ina003Resposta`));
											}}
											disabled={disabled}
											tabIndex={-1}
										/>
									</RCCTooltip>
								</div>
						
							</RCCGrid>
						</>
					) : (
						<>
						
							<RCCGrid>
								<Title size="lg" color="purple" bold>
									{`${translate("Por quê?")}:`}
								</Title>
								<Title size="lg" color="defaultColor">
									<RCCGrid dangerouslySetInnerHTML={{__html: `<span>${convertHTMLRawStringToHTML(field5Why.ina003Pergunta).html}</span>` }} />
								</Title>
							</RCCGrid>
							<RCCGrid>
								<Title size="lg" color="purple" bold>
									{`${translate("Resposta")}:`}
								</Title>
								<Title size="lg" color="defaultColor">
									<RCCGrid dangerouslySetInnerHTML={{__html: `<span>${convertHTMLRawStringToHTML(field5Why.ina003Resposta).html}</span>` }} />
								</Title>
							</RCCGrid>
						</>
					)}

					<hr />
				</RCCGrid>
				<br />
			</React.Fragment>
		</>
	);
};

export default FiveWhyItem;
